```vue
<template>
  <page-container>
    <!-- <page-header title="Interviews & Music Videos" /> -->
    <v-expansion-panels v-model="panel">
      <v-expansion-panel
        v-for="section in content"
        :key="section.title"
      >
        <v-expansion-panel-header color="grey darken-3">
          <span class="text-h5">
            {{ section.title }}
          </span>
        </v-expansion-panel-header>

        <v-expansion-panel-content
          color="grey darken-4 overflow-auto hide-scrollbar"
          style="max-height: 40vh"
        >
          <div class="d-flex justify-space-around flex-wrap">
            <template v-for="item in section.links">
              <div
                :key="item.link"
                class="mt-3 mx-1 grey--text"
                style="width: 240px;"
              >
                <div
                  class="py-1 px-2"
                  style="
                    background: black;
                    font-size: .8rem;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                  "
                >
                  {{ (item.playlist ? '[Playlist] ' : '') + item.title }}
                </div>

                <figure
                  class="thumbnail"
                  style="position: relative; cursor: pointer;"
                  @click="playVideo(item)"
                >
                  <v-img
                    :width="240"
                    :height="140"
                    :src="`//img.youtube.com/vi/${item.link}/mqdefault.jpg`"
                  />

                  <div class="centered">
                    <v-btn
                      fab
                      dark
                      small
                      color="red"
                      class="elevation-2"
                    >
                      <v-icon>mdi-play</v-icon>
                    </v-btn>
                  </div>
                </figure>
              </div>
            </template>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-dialog
      v-model="showDialog"
      :width="$vuetify.breakpoint.mdAndUp ? 840 : 420"
      persistent
      transition="dialog-bottom-transition"
      @input="onDialogInput"
    >
      <v-card>
        <v-toolbar dark>
          <span>{{ currentSong.playlist? `${currentSong.title} [PLAYLIST]` : currentSong.title }}</span>
          <span
            v-if="currentSong.channel"
            class="subtitle-2 grey--text pl-4"
          >
            ℗ {{ currentSong.channel }}
          </span>
          <v-spacer />
          <v-btn
            icon
            dark
            @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="ma-0 pa-0 text-center">
          <!-- YouTube Player -->
          <div
            id="youtube-player"
            :style="{
              width: playerWidth + 'px',
              height: playerHeight + 'px',
              margin: '0 auto'
            }"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </page-container>
</template>

<script>
export default {
  data: () => ({
    panel: 0,
    showDialog: false,
    currentSong: {},
    player: null,
    youtubeApiReady: false,

    content: [
      {
        title: 'Music Videos',
        links: [
          { link: '1bPipx0L71s', title: 'Kotha Chhilo', channel: 'Cozmik Harmony' },
          { link: 'KxY9mXfrXoY', title: 'Megh Boleche (Rabindrasangeet)', channel: 'GG Official' },
          { link: 'wrVMWd9ITKo', title: 'Madhobilata', channel: 'Melody Unlimited' },
          { link: 'QQqToVkTRzM', title: 'Koto Megh' },
          { link: 'K-Il4QuJ0SI', title: 'Tomaro Janala Ki' },
          { link: 'RWKp_BtLCX4', title: 'Ure Jaa Bhese Jaa', channel: 'Cozmik Harmony' },
          { link: 'MUJ55RhlNy8', title: 'Dujoner Hriday Theke', channel: 'Cozmik Harmony' },
          { link: 'lDxQrlPMH3I', title: 'Kusum Kusum', channel: 'Cozmik Harmony' },
          { link: 'CV5kKzQjDT0', title: 'Neel Chhata', channel: 'Cozmik Harmony' },
          { link: '986VR0ys_18', title: 'Chilte Rod', channel: 'Cozmik Harmony' },
          { link: 'UuAcI6EF74c', title: 'Tumi Nei', channel: 'Cozmik Harmony' },
          { link: '2rXfQV09zCU', title: 'Srabon Ghera', channel: 'Cozmik Harmony' },
          { link: 'gL5oDb8wwTI', title: 'Raateri Taray Taray' }
        ]
      },
      {
        title: 'Broadcasts',
        links: [
          { link: 'RtVJzvAXbzE', title: 'Aamar Rabi - R Plus', playlist: 'PLoUlkl8-2y5zqbEIz24S5ZIDSGmB8Y6-a' },
          { link: '7V6n628awuU', title: 'Sakal Sakal - DD Bangla' },
          { link: 'gNNnAzHL61Y', title: 'Good Morning Akash' },
          { link: '-jXsVlV4b5g', title: 'Obelay Adda - One TV' },
          { link: 'HuiUBscHB0E', title: 'Chorcha@Chilekotha [Part-I] - Cozmik Harmony' },
          { link: 'UOCiAfEEgeo', title: 'Chorcha@Chilekotha [Part-II] - Cozmik Harmony' },
          { link: 'rklA77aAfYY', title: 'A Tribute to Satinath Mukhopadhyay - Akash 8' },
          { link: 'KDc1K9Varag', title: 'A Tribute to Pintu Bhattacharya - Akash 8' },
          { link: 'r-zSeq7_suE', title: 'Charan Chhuye Jai - One TV' },
          { link: '8Gj9pSr9rnc', title: 'Gaan Ontohin - DD Bangla' }
        ]
      },
      {
        title: 'Live Concerts',
        links: [
          { link: 'VJl7c4yvp-k', title: 'Rang-Milanti [Part-I]' },
          { link: 'mB86kA5lDn0', title: 'Rang-Milanti [Part-I]' },
          { link: 'ykrKVCrZoM8', title: 'With Srikanta Acharyya [Part-I]' },
          { link: 'z9uYw-gwtJY', title: 'With Srikanta Acharyya [Part-II]' },
          { link: 'A9v3WxS9LEY', title: 'With Srikanta Acharyya [Part-III]' },
          { link: 'QhWLsM1yDd0', title: 'Tomaro Janala Ki' },
          { link: 'PVrhLruEiUg', title: 'Asansol Bangla Sangeet Mela 2022' },
          { link: 'bhzdl-1wHzY', title: 'In the memory of Hemanta Mukherjee' },
          { link: 'Nt2xWSQWmrY', title: 'With Amrita Chatterjee' }
        ]
      },
      {
        title: 'Interviews',
        links: [
          { link: 'AT9JFBn0Ijk', title: 'Chorcha@Taarkata [Part-I] - Cozmik Harmony' },
          { link: 'SAaHTFRBF1M', title: 'Chorcha@Taarkata [Part-II] - Cozmik Harmony' },
          { link: 'sN-7J69jZBM', title: 'Chorcha@Taarkata [Part-III] - Cozmik Harmony' },
          { link: 'hZIqoOtcJHY', title: 'Gaan Tea- Kolkata Kalling', playlist: 'PL2rZTHRo2X7GDG3mAK8xYWRyxGo3I7uGH' },
          { link: 'V1M_dsNJcCc', title: 'Aamar Maa - One TV' },
          { link: 'D4juEYSQQwk', title: 'Ankora Radio Adda - Songe Kingshuk' },
          { link: 'dJCnxxV29ng', title: 'Random Interview in Australia' },
          { link: 'zU3AiOF0t2g', title: 'Telephonic Interview [Part-I] - Srijoner Itikotha' },
          { link: 'y97UFLK0WCQ', title: 'Telephonic Interview [Part-II] - Srijoner Itikotha' }
        ]
      }
    ]
  }),

  computed: {
    playerWidth () {
      return this.$vuetify.breakpoint.mdAndUp ? 800 : 400
    },

    playerHeight () {
      return this.$vuetify.breakpoint.mdAndUp ? 500 : 250
    }
  },

  mounted () {
    this.loadYouTubeAPI()
  },

  beforeDestroy () {
    this.destroyPlayer()
  },

  methods: {
    /**
     * Load the YouTube IFrame API only once.
     */
    loadYouTubeAPI () {
      // API already loaded
      if (window.YT && window.YT.Player) {
        this.youtubeApiReady = true
        return
      }

      // Another component/page may already be loading it
      if (window.youtubeApiLoading) {
        window.youtubeApiCallbacks = window.youtubeApiCallbacks || []

        window.youtubeApiCallbacks.push(() => {
          this.youtubeApiReady = true
        })

        return
      }

      window.youtubeApiLoading = true
      window.youtubeApiCallbacks = []

      window.onYouTubeIframeAPIReady = () => {
        this.youtubeApiReady = true
        window.youtubeApiLoading = false

        window.youtubeApiCallbacks.forEach(callback => callback())
        window.youtubeApiCallbacks = []
      }

      const tag = document.createElement('script')

      tag.src = 'https://www.youtube.com/iframe_api'
      tag.async = true

      document.head.appendChild(tag)
    },

    /**
     * Open the dialog and play the selected video/playlist.
     */
    playVideo (song) {
      this.currentSong = song
      this.showDialog = true

      this.$nextTick(() => {
        this.waitForYouTubePlayer()
      })
    },

    /**
     * Wait until both:
     *
     * 1. Dialog has rendered the #youtube-player element
     * 2. YouTube API is ready
     */
    waitForYouTubePlayer () {
      if (!this.youtubeApiReady) {
        setTimeout(() => {
          this.waitForYouTubePlayer()
        }, 100)

        return
      }

      if (!document.getElementById('youtube-player')) {
        setTimeout(() => {
          this.waitForYouTubePlayer()
        }, 100)

        return
      }

      this.createPlayer()
    },

    /**
     * Create the YouTube player.
     */
    createPlayer () {
      this.destroyPlayer()

      this.player = new window.YT.Player('youtube-player', {
        width: this.playerWidth,
        height: this.playerHeight,

        playerVars: {
          autoplay: 1,
          playsinline: 1,
          rel: 0
        },

        events: {
          onReady: this.onPlayerReady,
          onError: this.onPlayerError
        }
      })
    },

    /**
     * Player is ready.
     *
     * Load either:
     * - the playlist
     * - or the individual video
     */
    onPlayerReady (event) {
      if (!this.currentSong || !this.currentSong.link) {
        return
      }

      if (this.currentSong.playlist) {
        event.target.loadPlaylist({
          listType: 'playlist',
          list: this.currentSong.playlist,
          index: 0,
          startSeconds: 0
        })
      } else {
        event.target.loadVideoById({
          videoId: this.currentSong.link,
          startSeconds: 0
        })
      }
    },

    /**
     * Handle YouTube errors.
     *
     * Useful for diagnosing videos which don't allow embedding.
     */
    onPlayerError (event) {
      console.error('YouTube Player Error:', event.data)

      switch (event.data) {
        case 2:
          console.error('Invalid video ID or playlist.')
          break

        case 5:
          console.error('HTML5 player error.')
          break

        case 100:
          console.error('Video not found or private.')
          break

        case 101:
        case 150:
          console.error('Video owner does not allow embedding.')
          break

        case 153:
          console.error(
            'Video cannot be played because the request does not contain a valid HTTP Referer.'
          )
          break

        default:
          console.error('Unknown YouTube error.')
      }
    },

    closeDialog () {
      this.showDialog = false

      this.destroyPlayer()

      setTimeout(() => {
        this.currentSong = {}
      }, 250)
    },

    onDialogInput (value) {
      if (!value) {
        this.destroyPlayer()
      }
    },

    destroyPlayer () {
      if (this.player) {
        try {
          this.player.stopVideo()
          this.player.destroy()
        } catch (error) {
          console.warn('Unable to destroy YouTube player:', error)
        }

        this.player = null
      }
    }
  },

  components: {
    PageContainer: () => import('@/components/reusable/PageContainer')
    // PageHeader: () => import('@/components/reusable/PageHeader')
  }
}
</script>

<style lang="scss" scoped>
.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.thumbnail {
  div:nth-child(1) {
    filter: saturate(0.75);
  }

  &:hover {
    div:nth-child(1) {
      filter: saturate(1);
    }
  }
}
</style>
